export default __webpack_public_path__ + "static/media/WhatsappSupport.7ea4b910.png";